import React, { useState, useEffect, useCallback } from 'react';
import Main from '../componentes/Main';
import Axios from 'axios';
import { Grid, Box } from "@material-ui/core";
import { MultiSelect } from 'primereact/multiselect';
import { 
    Spinner, 
    Card, 
    Typography, 
    Input, 
    IconButton, 
    Tooltip, 
    Dialog, 
    DialogHeader, 
    DialogBody, 
    DialogFooter, 
    Button, 
    Textarea,
    Checkbox
} from '@material-tailwind/react';
import { MagnifyingGlassIcon, TrashIcon } from '@heroicons/react/24/outline';
import Swal from 'sweetalert2';
import { faWindowClose } from '@fortawesome/free-solid-svg-icons';
import { useContextoGlobal } from '../Context/contextoGlobal';
import ExportToExcelGeneric from '../componentes/exportExcelGeneric';
import { PiePagina, Paginacion, usePaginacion } from '../Helpers/importacionesComunes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'react-quill/dist/quill.snow.css';
import 'quill-paste-smart';
import ChipInput from '../componentes/MUI/ChipInputs';
import DragComponent from '../componentes/DragDrop/DragComponent';
import "primereact/resources/themes/saga-blue/theme.css";
import {MailsEnviados} from '../componentes/MailsEnviados'
import {Dialogos} from '../componentes/MUI/Dialogos'
const IProvinciaModel = {
    nombre: '',
}

export default function EnvioEmails({ usuario,emails_array,titulo,cerrar,modulo }) {
    const [provinciasList, setProvinciasList] = useState([])
    const [asuntoEmail, setAsuntoEmail] = useState('')
    const [provinciaId, setProvinciaId,] = useState(0)
    const [buscandoDatos, setBuscandoDatos] = useState(false)
    const [editorValue, setEditorValue] = useState('');
    const [open, setOpen] = React.useState(false);
    const [openEmailSearch, setOpenEmailSearch] = React.useState(false);
    const [provinciaData, setProvinciaData] = useState(IProvinciaModel);
    const [recipients, setRecipients] = useState([]);
    const [emailFiles, setEmailFiles] = useState([]);
    const [fetchedEmails, setFetchedEmails] = useState([]);
    const [regiones, setRegiones] = useState([]);
    const [distritos, setDistritos] = useState([]);
    const [rangos,setRangos] = useState([]);
    const [selectedEmails, setSelectedEmails] = useState([])
    const [isFetchingEmails, setIsFetchingEmails] = useState(false)
    const [isSendingEmails, setIsSendingEmails] = useState(false)
    const [isTestEmails, setIsTestEmails] = useState(false)
    const [parametros, setParametros] = useState({
        id_region: null,
        id_distrito: null,
        id_rango: null,
        sexo: null
    })
   const [verHistorial,setVerHistorial]=useState(false)

    useEffect(() => {
        if(emails_array){
            const uniqueEmails = new Set(emails_array);
            setRecipients([...uniqueEmails]);
        }else{
            buscarTablasGenerales()
        }
    }, [])

    const buscarTablasGenerales = async () => {
        try {
            setBuscandoDatos(true)
            const vectorResultados = await Promise.all([Axios.get('/api/tablasgenerales/rangos'),
            Axios.get('/api/tablasgenerales/regiones/*'),
            Axios.get(usuario.sede_admin ? '/api/tablasgenerales/distritos/*' : `/api/tablasgenerales/distritos/${usuario.id_region}`)
            ])
            setRangos(vectorResultados[0].data)
            setRegiones(vectorResultados[1].data)
            setDistritos(vectorResultados[2].data.filter(item => item.id_distrito > 0))
            setBuscandoDatos(false)
        } catch (err) {
            setBuscandoDatos(false)
            console.log('Error al buscar los datos generales')
        }
    }

    const handleOpen = (isTest = false) => { 
        setIsTestEmails(isTest);
        setOpen(!open);
    }

    const handleSecureOpen = async (isTest = false) => {
        
    if(usuario.id_usuario===28){
        setIsTestEmails(isTest);
        setOpen(true);
        return
    }

    const { value: password } = await Swal.fire({
        title: 'Confirmar envío',
        input: 'password',
        inputLabel: 'Ingrese su clave para continuar',
        inputPlaceholder: 'Clave',
        inputAttributes: {
            autocapitalize: 'off',
            autocorrect: 'off'
        },
        showCancelButton: true,
        confirmButtonText: 'Continuar',
        cancelButtonText: 'Cancelar'
    });

    if (!password) return; 

     try {
        const resp = await Axios.post(
            `/api/tablasgenerales/validar/enviomails/${usuario.usuario}`,
            { password }
        );

        if (!resp.data.resultado) throw new Error();

        setIsTestEmails(isTest);
        setOpen(true);

    } catch {
        Swal.fire({
            icon: 'error',
            title: 'Clave incorrecta',
            text: 'No tiene permiso para enviar emails'
        });
    }

};


    const handleEmailOpenDialog = () => { 
        setOpenEmailSearch(true);
    }

    const cleanAllEmails = () => { 
        setRecipients([]);
    }


    const closeEmailOpenDialog = () => { 
        setOpenEmailSearch(false);
    }

    const test = async () => {
    const result = await Swal.fire({
        icon: 'info',
        title: `<p>Envío en proceso</p>`,
        html: `<div>
                <p>textoooo</p>
                <br><br>
                <strong>Código web del envío:</strong>
                <p>153211</p>
                <br><br>
                <p>Por favor revise el historial de mails enviados y verifique el resultado antes de realizar otro envío</p>
               </div>`,
        allowOutsideClick: false, // <<< NO se cierra al hacer clic afuera
        allowEscapeKey: false,     // <<< NO se cierra con la tecla Esc
        confirmButtonText: 'OK'
    });

    if (result.isConfirmed) {
        setVerHistorial(true)
    }
};

    const sendEmail = async () => {
        if (!asuntoEmail) { 
            Swal.fire({
                icon: 'error',
                title: `<p>Por favor, complete el campo del asunto del correo electrónico.</p>`,
                showCancelButton: true,
            });
            setOpen(true);
            return;
        }

        if (recipients.length === 0) { 
            Swal.fire({
                icon: 'error',
                title: `<p>No ha seleccionado ningún destinatario</p>`,
                showCancelButton: true,
            });
            setOpen(true);
            return;
        }

        if (!editorValue) { 
            Swal.fire({
                icon: 'error',
                title: `<p>Por favor, introduzca el cuerpo del correo electrónico.</p>`,
                showCancelButton: true,
            });
            setOpen(true);
            return;
        }

        const formData = new FormData();
        const recipientsList = !isTestEmails ? recipients : recipients.map(email => "pablo.david.st@gmail.com");
        setIsTestEmails(false);
        setIsSendingEmails(true);
        formData.append('asunto', asuntoEmail);
        formData.append('mensaje', editorValue);
        formData.append('id_usuario', usuario.id_usuario);
        formData.append('modulo', modulo || 'uadadmin general');
        formData.append('observaciones', titulo || '');
        formData.append('destinatarios', JSON.stringify(recipientsList));

        if (emailFiles && emailFiles.length > 0) {
            emailFiles.forEach((file, index) => {
                formData.append(`adjunto`, file); // "adjunto" debe coincidir con el nombre esperado por Multer para que req.files no llegue vacío
            });
        }


        try {
            const resultado = await Axios.post(`${process.env.REACT_APP_API_UAD_BASE}/api/tablasgenerales/enviomultiplemails`, formData, {
                // headers: {
                //     'Content-Type': 'multipart/form-data'
                // }, 
                // No definir Content-Type en FormData: hacerlo rompe el boundary y evita que Multer reciba archivos
                timeout: 300000
            });
           
            const result = await  Swal.fire({
                icon: 'info',
                allowOutsideClick: false, // <<< NO se cierra al hacer clic afuera
                allowEscapeKey: false,     // <<< NO se cierra con la tecla Esc
                confirmButtonText: 'OK',                
                title: `<p>Envío en proceso</p>`,
                html:`<div>
                <p>${resultado.data?.message}</p>
                <br><br>
                <strong>Código web del envío:</strong>
                <p>${resultado.data?.codigo_web}</p>
                <br><br>
                <p>Por favor revise el historial de mails enviados y verifique que se haya completado el proceso antes de realizar otro envío</p>
                </div>`
            });
            
            if (result.isConfirmed) {
                 setVerHistorial(true)
            }

            handleOpen();
            setIsSendingEmails(false);
            if(cerrar){
                cerrar()
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: `<p>Error al enviar el email</p>`,
                html: `<div>
                    <h5>Por favor reporte este error al equipo de sistemas:</h5>
                    <div style="margin-top: 10px; font-weight: bold; color: #d33;">
                        ${
                            // 1. Intentamos buscar el mensaje que viene del backend
                            error.response?.data?.message || 
                            // 2. Si no hay message pero hay data directa (un string)
                            (typeof error.response?.data === 'string' ? error.response.data : null) || 
                            // 3. Mensaje por defecto si el servidor no respondió (ej. caída de red)
                            `Error en el servicio de envío de mails a las ${new Date().toLocaleString()}`
                        }
                    </div>
                </div>`,
                showCancelButton: true,
            });
            console.log(error);
            setOpen(true);
            setIsSendingEmails(false);
            setIsTestEmails(false);
        }
    };

    const handleEditorChange = (e) => {
        setEditorValue(e.target.value);
    };

    const openPreview = () => {
        const newWindow = window.open();
        newWindow.document.write(editorValue);
        newWindow.document.close();
    };

    const normalizarParametros = () => {
        return Object.entries(parametros).reduce((acc, [key, value]) => {
            console.log("acc", acc);
            acc[key] = value === "-1" ? null : value;
            return acc;
        }, {});
    };

    const getSearchEmails = async () => { 
        try {

            const newParams = normalizarParametros();
            setIsFetchingEmails(true);
            const resp = await Axios.post(`${process.env.REACT_APP_API_UAD_BASE}/api/tablasgenerales/enviomails/listadoemails`, newParams);
            if (resp.status === 200) { 
                const emails = resp.data
                    .filter(item => item.email && item.email.trim() !== '')
                    .map(item => ({ label: item.email, value: item.email.toLowerCase() }));
                setFetchedEmails(emails);
            }
            setIsFetchingEmails(false);
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: `<p>No se han encontrado emails asociado a la búsqueda</p>`,
                showCancelButton: true,
            });
            console.log("error", error);
            setOpen(true);
            setIsFetchingEmails(false);
        }
    }

    const handleEmailsSelection = async () => { 
        const uniqueEmails = new Set([...recipients, ...fetchedEmails.map(item => item.value)]);
        setRecipients([...uniqueEmails]);
        closeEmailOpenDialog();
    }
    if(isSendingEmails){ 
    return <Box sx={{display:'flex',
                            flexDirection:'column',
                            alignItems:'center',
                            justifyContent:'center',
                            marginLeft:'auto',
                            marginRight:'auto',
                           }}> 
                <div className='flex flex-col justify-center items-center mt-20'>
                  <Spinner className="h-12 w-12" />
                  <span className="cargando font-semibold text-[15px]">Enviando...</span>
                </div>
    </Box>}

    return <div className='w-full flex flex-col justify-center items-center lg:!m-6 xl:!m-6'>
        <Box sx={{display:'flex', width:'100%',padding:'1.5rem'}}>
               <Button onClick={()=>setVerHistorial(true)}>Historial de mails enviados</Button>
        </Box>
        <Typography variant="h4" className="flex ">
            Enviar Email
        </Typography>
        <Card className='w-full justify-center items-center flex p-5 justify-left mt-4'>
          <div className='flex w-full lg:w-96 xl:w-[42rem] mb-2 gap-3 relative flex-col'>
            <Input
              type="text"
              label="Asunto del Email"
              value={asuntoEmail}
              onChange={(e) => { setAsuntoEmail(e.target.value) }}
              color='black'
            />

            <div className='relative w-full'>
                <ChipInput 
                    chips={recipients}
                    setChips={setRecipients}
                />
                {!emails_array && <div className='flex flex-col absolute top-1 right-[-30px]'>
                    <MagnifyingGlassIcon width={20} height={20} className='cursor-pointer hover:opacity-85' onClick={handleEmailOpenDialog}/>
                    <TrashIcon width={20} height={20} className='cursor-pointer hover:opacity-85 mt-2' onClick={cleanAllEmails}/>
                </div>}
                {recipients.length ? `(Seleccionados: ${recipients.length})` : null}
            </div>
            
          </div>
          <div className='flex flex-col w-full lg:w-96 xl:w-[42rem]'>
            <Textarea
                value={editorValue}
                label='Contenido del Email'
                onChange={handleEditorChange}
                className='w-full h-[200px] m-h-[200px] overflow-y-auto p-[10px] border-2 border-gray-300 rounded-md text-[14px]'
            />
            <Button onClick={openPreview} className='mt-3'>
                Ver Previsualización
            </Button>
        </div>

          <DragComponent 
            ownerLicense={emailFiles}
            setOwnerLicense={setEmailFiles}
          />
          <Button onClick={() => handleSecureOpen()} className='mt-5 w-[300px]'>Enviar</Button>
          {/* <Button onClick={() => handleOpen(true)} className='mt-5 w-[300px]'>Enviar TEST</Button> */}
        </Card>
        <Dialog open={open} handler={handleOpen}>
            <DialogHeader>Enviar Emails {titulo ? `(${titulo})` : ''} </DialogHeader>
            <DialogBody className="xl:p-10">
                <Typography
                    variant="small"
                    color="blue-gray"
                    className="mb-1 font-medium "
                >
                    {recipients.length} e-mails seleccionados
                    ¿Está seguro de realizar esta operación?
                </Typography>
            </DialogBody>
            <DialogFooter className="space-x-2">
                <Button 
                    variant="gradient" 
                    color="blue" 
                    onClick={sendEmail}
                    disabled={isSendingEmails}
                >
                    {isSendingEmails ? <Spinner className='w-4 h-4 m-auto' /> : 'Aceptar'}
                </Button>
                <Button variant="text" color="blue-gray" onClick={handleOpen}>
                    Cancelar
                </Button>
            </DialogFooter>
        </Dialog>
        <Dialogos open={verHistorial} 
                        fullscreen={false}
                        maxWidth={'xl'}
                        procesarCancelar = {()=>setVerHistorial(false)}
                      >
                        <MailsEnviados/>
            </Dialogos>
        <Dialog open={openEmailSearch} handler={handleEmailOpenDialog}>
            <DialogHeader>Buscar Emails</DialogHeader>
            <DialogBody className="xl:p-10">
                <Parametros 
                    parametros={parametros}
                    setParametros={setParametros}
                    regiones={regiones}
                    distritos={distritos}
                    rangos={rangos}
                    usuario={usuario}
                    fetchedEmails={fetchedEmails}
                    selectedEmails={selectedEmails}
                    setSelectedEmails={setSelectedEmails}
                    getSearchEmails={getSearchEmails}
                    isFetchingEmails={isFetchingEmails}
                />
            </DialogBody>
            <DialogFooter className="space-x-2">
                <Button 
                    variant="gradient" 
                    color="blue" 
                    onClick={handleEmailsSelection}
                >
                    Agregar
                </Button>
                <Button variant="text" color="blue-gray" onClick={() => setOpenEmailSearch(false)}>
                    Cancelar
                </Button>
            </DialogFooter>
        </Dialog>
    </div>
}

function Parametros({ 
    parametros, 
    setParametros, 
    rangos, 
    regiones, 
    usuario, 
    distritos, 
    fetchedEmails,
    selectedEmails,
    setSelectedEmails,
    getSearchEmails,
    isFetchingEmails
}) {

    const regionesSegunUsuario = regiones.filter(item => item.id_region == usuario.id_region || usuario.sede_admin)
    const [distritosRegion, setDistritosRegion] = useState([])
    const [buscarEmails, setBuscarEmails] = useState(false)
    const { esCelular } = useContextoGlobal();

    useEffect(() => {
        setParametros({ ...parametros, id_distrito: null })
        setDistritosRegion(distritos.filter(item => item.id_region == parametros.id_region))
    }, [parametros.id_region])

    const handleCheckSexo = (type, value) => {
        setParametros({ ...parametros, [type]: value })
    }

    const cleanSelectedEmails = () => {
        setSelectedEmails([]);
    }

    return <div className="w-full mb-2">
        <div className="mt-[-30px] flex f-col">
            <div className={`${esCelular ? 'mt-2' : 'grid grid-cols-3 mt-4'} justify-left`}>
                <Typography variant="h5" color="blue-gray" className="mt-1">
                    Región
                </Typography>
                <div className="col-span-2 mt-1">
                    <Seleccionador id='select-region' nombre="Todos" vector={regionesSegunUsuario} valor={parametros.id_region} onchange={(e) => setParametros({ ...parametros, id_region: e.target.value })} claves={{ id: 'id_region', nombre: 'nombre' }} />
                </div>
            </div>
            <div className={`${esCelular ? 'mt-2' : 'grid grid-cols-3 mt-4'} justify-left`}>
                <Typography variant="h5" color="blue-gray" className="mt-1">
                    Distrito
                </Typography>
                <div className="col-span-2 mt-1">
                    <Seleccionador id='select-distrito' nombre="Todos" vector={distritosRegion} valor={parametros.id_distrito} onchange={(e) => setParametros({ ...parametros, id_distrito: e.target.value })} claves={{ id: 'id_distrito', nombre: 'nombre' }} />
                </div>
            </div>
            <div className={`${esCelular ? 'mt-2' : 'grid grid-cols-3 mt-4'} justify-left`}>
                <Typography variant="h5" color="blue-gray" className="mt-1">
                    Rango
                </Typography>
                <div className="col-span-2 mt-1">
                    <SeleccionadorRangos vector={rangos} valor={parametros.id_rango} nombre="Todos" onchange={(e) => setParametros({ ...parametros, id_rango: e.target.value })} limpiar={() => setParametros({ ...parametros, id_rango: null })} />
                </div>
            </div>

            <div className="grid grid-cols-3 justify-left mt-2">
                <Typography variant="h5" color="blue-gray" className="mt-2">
                    Sexo
                </Typography>
                <div className="col-span-2 flex space-x-2 w-full mt-1">
                    <Checkbox
                        label="Masculino"
                        ripple={false}
                        checked={parametros.sexo == 'M'} 
                        onClick={() => handleCheckSexo('sexo', 'M')}
                        className='w-5 h-5'
                    />
                    <Checkbox
                        label="Femenino"
                        ripple={false}
                        checked={parametros.sexo == 'F'} 
                        onClick={() => handleCheckSexo('sexo', 'F')}
                        className='w-5 h-5'
                    />

                    <Checkbox
                        label="Todos"
                        ripple={false}
                        checked={parametros.sexo == null} 
                        onClick={() => handleCheckSexo('sexo', null)}
                        className='w-5 h-5'
                    />
                </div>
            </div>
            
            <div className='flex gap-2 justify-center'>
                <Button 
                    variant="gradient" 
                    onClick={() => { getSearchEmails(); setBuscarEmails(true); }}
                    className='w-[200px] mt-4 mb-3'
                    disabled={isFetchingEmails}
                >
                    {isFetchingEmails ? <Spinner className='w-4 h-4 m-auto' /> : 'Buscar Emails'}
                </Button>

                {selectedEmails.length > 0 &&
                    <Button 
                        variant="text" 
                        onClick={cleanSelectedEmails}
                        className='w-[200px] mt-4 mb-3 text-red-400 bg-red-100 hover:bg-red-200'
                    >
                        Limpiar Emails
                    </Button> 
                }
            </div>

            {buscarEmails && !isFetchingEmails &&
                <div className="flex m-auto">
                    <Typography variant="h7" color="blue-gray" className="mt-2 text-green-500">
                        {fetchedEmails.length} Emails Encontrados
                    </Typography>
                </div>
            }

            <div className="hidden grid-cols-3 justify-left mt-2 relative z-[1000px]">
                <Typography variant="h5" color="blue-gray" className="mt-2">
                    Emails 
                </Typography>
                <div className="col-span-2 mt-1 border-[2px] border-[#ccc] rounded-md p-2">
                    <MultiSelect
                        value={selectedEmails}
                        options={fetchedEmails}
                        onChange={(e) => setSelectedEmails(e.value)} 
                        placeholder="Seleccionar Emails" 
                        display="chip"
                        className="w-full md:w-20rem" 
                    />
                </div>
            </div>
        </div>
    </div>
}

export function Seleccionador({ vector, onchange, valor, nombre, noDefault, name, classancho, limpiar, claves, id }) {
    let clasesSelect = "block appearance-none w-100 select-titulo rounded shadow leading-tight";

    if (classancho) {
        clasesSelect = `block appearance-none ${classancho} select-titulo rounded shadow leading-tight`
    }
    return (
        <div className="flex flex-col sel select-ui-data w-full">
            <select value={valor} name={name ? name : ''} className='h-9' onChange={onchange} id={id ? id : null}>
                {noDefault ? null : <option value="-1" key="-1">{nombre}</option>}
                {vector.map(item => <option value={item[claves.id]} key={item[claves.id]}>{item[claves.nombre]}</option>)}
            </select>
            {valor != "-1" && limpiar &&
                <button>
                    <FontAwesomeIcon className="ic-abm"
                        icon={faWindowClose}
                        onClick={limpiar} />
                </button>}
        </div>
    )
}

function SeleccionadorRangos({ vector, onchange, valor, nombre, noDefault, name, classancho, limpiar }) {
    let clasesSelect = "block appearance-none w-100 select-titulo rounded shadow leading-tight";

    if (classancho) {
        clasesSelect = `block appearance-none ${classancho} select-titulo rounded shadow leading-tight`
    }

    return (
        <div className="flex flex-col sel select-ui-data w-full">
            <select value={valor} name={name ? name : ''} className='h-9' onChange={onchange}>
                {noDefault ? null : <option value="-1" key="-1">{nombre}</option>}
                {vector.map(item => <option value={item.id_rango} key={item.id_rango}>{item.nombre}</option>)}
            </select>
        </div>
    )

}

function base64ToFile(base64, filename, mimeType) {
  const byteString = atob(base64.split(',')[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new File([ab], filename, { type: mimeType });
}